// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"272":"admin-login","594":"about","884":"admin"}[chunkId] + "." + {"272":"7e50a638","594":"af6853e2","884":"8520456e"}[chunkId] + ".js";
};